<template>
  <div class="home-page">
    <el-row class="row" :gutter="20">
      <el-col :span="6">
        <!-- 最新动态 -->
        <v-card class="news">
          <router-link to="/Articles">
            <span class="more more1">查看更多></span>
          </router-link>
          <h4>最新动态</h4>
          <ul class="list">
            <li class="item" v-for="(item, $index) in Articles" :key="$index">
              <router-link
                :to="{ name: 'ArticleDetail', params: { id: item.id } }"
              >
                <span class="article-title">{{ item.title }}</span>
              </router-link>
              <span class="date">{{
                item.creationTime | date('YYYY/MM/DD')
              }}</span>
            </li>
          </ul>
          <el-row class="sub-row" :gutter="16">
            <el-col :span="12">
              <router-link to="/entrusted">
                <el-button class="block-btn" type="primary">采购下单</el-button>
              </router-link>
            </el-col>
            <el-col :span="12">
              <router-link to="/entrusted">
                <el-button class="block-btn" type="primary">租赁下单</el-button>
              </router-link>
            </el-col>
          </el-row>
          <el-row class="sub-row" :gutter="16">
            <el-col :span="12">
              <el-button
                class="block-btn"
                @click.native="toTrustApply()"
                type="primary"
                >委托下单</el-button
              >
            </el-col>
            <el-col :span="12">
              <router-link to="/newrepair">
                <el-button class="block-btn" type="primary">维修下单</el-button>
              </router-link>
            </el-col>
          </el-row>
          <el-button class="block-btn" type="primary" @click.native="toShip()"
            >我要发货</el-button
          >
        </v-card>
      </el-col>
      <el-col :span="18">
        <!-- 轮播图 -->
        <el-carousel
          class="carousel"
          height="354px"
          arrow="never"
          trigger="click"
        >
          <!-- <el-carousel-item v-for="item in picList" :key="item"> -->
          <!-- <el-carousel-item>
              <img src="../../assets/banner.png">
            </el-carousel-item> -->
          <el-carousel-item>
            <img src="../../assets/banner1.jpg" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/banner2.jpg" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/banner6.jpg" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
    <!--<steps-bar :steps="[{key: 'commit', title: '提交订单'}, {key: 'receiving', title: '待收货', state: 'failure'}, {key: 'qc', title: '待质检'}, {key: 'pay', title: '已支付'}, {key: 'finished', title: '已完成'}]" :step="2"></steps-bar>-->
    <el-row class="row" :gutter="20">
      <el-col :span="6">
        <!-- 物流派送查询 -->
        <v-card class="query-card">
          <h4>物流派送查询</h4>
          <div class="img-wrapper text-center">
            <img src="../../assets/logistics.png" />
          </div>
          <router-link to="/logistics">
            <el-button class="block-btn" style="margin-top: 32px" type="primary"
              >物流查询</el-button
            >
          </router-link>
        </v-card>
      </el-col>
      <el-col :span="6">
        <!-- 库存查询 -->
        <v-card class="query-card">
          <h4>库存查询</h4>
          <el-row class="form-item">
            <el-select
              v-model="inventorySearch.type"
              class="max-width"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option label="代管库" value="1"></el-option>
              <el-option label="委托共享库" value="2"></el-option>
            </el-select>
          </el-row>
          <el-row class="form-item" style="margin-bottom: 16px">
            <el-input
              v-model="inventorySearch.word"
              class="query-card-textarea"
              type="textarea"
              placeholder="请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
            ></el-input>
          </el-row>
          <el-row class="action-bar" :gutter="20">
            <el-col :span="24">
              <el-button
                class="block-btn"
                type="primary"
                @click="handleSeach('inventory')"
                >查询</el-button
              >
            </el-col>
          </el-row>
        </v-card>
      </el-col>
      <el-col :span="6">
        <!-- 租赁价格查询 -->
        <v-card class="query-card">
          <h4>租赁价格查询</h4>
          <el-row class="form-item" style="margin-bottom: 0">
            <el-input
              v-model="leaseSearch.word"
              class="query-card-textarea"
              type="textarea"
              placeholder="请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
            ></el-input>
          </el-row>
          <!-- <div class="last-record"> -->
          <!-- <label>最近查询记录</label>
            <p>您最近没有查询记录</p> -->
          <!-- </div> -->
          <el-row style="height: 67px; overflow: hidden">
            <span style="padding-bottom: 5px">热租产品：</span><br />
            <a
              class="questionBtn"
              @click="toLeasePriceByModelName('TP07打印机')"
              href="javascript::"
              >TP07打印机</a
            >
            <a
              class="questionBtn"
              @click="toLeasePriceByModelName('XE送钞平台')"
              href="javascript::"
              >XE送钞平台</a
            >
            <a
              class="questionBtn"
              @click="toLeasePriceByModelName('日立CS组件')"
              href="javascript::"
              >日立CS组件</a
            >
            <a
              class="questionBtn"
              @click="toLeasePriceByModelName('XE带测量站V模块')"
              href="javascript::"
              >XE带测量站V模块</a
            >
            <a
              class="questionBtn"
              @click="toLeasePriceByModelName('12款凭条打印机')"
              href="javascript::"
              >凭条打印机（12款）</a
            >
          </el-row>
          <el-row class="action-bar action-bar-mg-top" :gutter="20">
            <el-col :span="24">
              <el-button
                class="block-btn"
                type="primary"
                @click="handleSeach('lease')"
                >查询</el-button
              >
            </el-col>
          </el-row>
        </v-card>
      </el-col>
      <el-col :span="6">
        <!-- 维修价格查询 -->
        <v-card class="query-card">
          <h4>维修价格查询</h4>
          <el-row class="form-item" style="margin-bottom: 0">
            <el-input
              v-model="repairSearch.word"
              class="query-card-textarea"
              type="textarea"
              placeholder="请输入物料名称或物料编码，如需查询多个请用英文逗号隔开，最多支持5个查询"
            ></el-input>
          </el-row>
          <!-- <div class="last-record"> -->
          <!-- <label>最近查询记录</label>
            <p>您最近没有查询记录</p> -->
          <!-- </div> -->
          <el-row style="height: 67px; overflow: hidden">
            <span style="padding-bottom: 5px">维修分类：</span><br />
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(12)"
              href="javascript::"
              >循环模块</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(4)"
              href="javascript::"
              >出钞模块</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(2)"
              href="javascript::"
              >键盘</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(5)"
              href="javascript::"
              >显示器</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(10)"
              href="javascript::"
              >主机</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(7)"
              href="javascript::"
              >读卡器</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(6)"
              href="javascript::"
              >凭条打印机</a
            >
            <a
              class="questionBtn"
              @click="toRepairPriceByModuleId(13)"
              href="javascript::"
              >流水打印机</a
            >
            <!-- <router-link class="questionBtn" to="/helpList/维修业务简介">板件类</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">BV</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">EPP</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">显示器</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">电源</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">打印机</router-link>
            <router-link class="questionBtn" to="/helpList/维修价格查询">机芯各模块</router-link> -->
          </el-row>
          <el-row class="action-bar action-bar-mg-top" :gutter="20">
            <el-col :span="24">
              <el-button
                class="block-btn"
                type="primary"
                @click="handleSeach('repair')"
                >查询</el-button
              >
            </el-col>
          </el-row>
        </v-card>
      </el-col>
    </el-row>
    <el-row class="row" :gutter="20" type="flex">
      <el-col :span="6">
        <!-- 快速入口 -->
        <v-card class="max-height" style="min-height: 664px">
          <h4>快速入口</h4>
          <el-menu class="menu" :router="true" @select="menuSelect">
            <el-menu-item
              class="menu-item"
              v-for="entry in quickEntrys"
              :key="entry.index"
              :index="entry.index"
            >
              <i class="fa fa-list-ul"></i>{{ entry.name }}</el-menu-item
            >
          </el-menu>
        </v-card>
      </el-col>
      <el-col :span="18">
        <!-- 库存、物流、维修 -->
        <v-card class="max-height">
          <div class="inventory">
            <router-link to="/entrusted">
              <el-button class="more" type="primary" size="mini"
                >查看更多</el-button
              >
            </router-link>
            <h4 class="table-title">库存查询</h4>
            <el-table
              class="horizontal-padding-10-table"
              :data="HomeData.productQuantityItems"
            >
              <el-table-column
                label="物品名称"
                :formatter="formatProductTable"
                width="180px"
                prop="productName"
              >
                <template scope="scope">
                  <el-popover trigger="hover" placement="right-start">
                    <p>{{ scope.row.productName }}</p>
                    <div slot="reference">
                      <p v-if="scope.row.productName.length > 12">
                        {{ scope.row.productName.substring(0, 12) + '...' }}
                      </p>
                      <p v-else>{{ scope.row.productName }}</p>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="品牌" prop="brandName"></el-table-column>
              <el-table-column label="机型" prop="modelName"></el-table-column>
              <el-table-column
                label="品项"
                prop="conditionName"
              ></el-table-column>
              <el-table-column label="区域" prop="regionName"></el-table-column>
              <el-table-column label="模块" prop="moduleName"></el-table-column>
              <el-table-column
                label="库存数量"
                prop="quantity"
              ></el-table-column>
            </el-table>
          </div>
          <div class="logistics">
            <router-link to="/logistics">
              <el-button class="more" type="primary" size="mini"
                >查看更多</el-button
              >
            </router-link>
            <h4 class="table-title">物流</h4>
            <el-table
              class="horizontal-padding-10-table"
              :data="HomeData.deliveryOrders"
            >
              <el-table-column
                label="物流单号"
                min-width="100px"
                prop="orderCode"
              ></el-table-column>
              <el-table-column label="状态" min-width="80px">
                <template scope="props">{{
                  props.row.state | LogisticsState
                }}</template>
              </el-table-column>
              <el-table-column label="客户名称/编码" min-width="180px">
                <template scope="props"
                  >{{ props.row.partnerName }}/{{
                    props.row.partnerCode
                  }}</template
                >
              </el-table-column>
              <el-table-column
                label="配送员"
                min-width="90px"
                prop="deliveryEmployeeName"
              ></el-table-column>
              <el-table-column label="发货时间" min-width="168px">
                <template scope="props">{{
                  props.row.shippedDate | date('YYYY/MM/DD HH:mm:ss')
                }}</template>
              </el-table-column>
              <el-table-column label="到货时间" min-width="168px">
                <template scope="props">{{
                  props.row.receivedDate | date('YYYY/MM/DD HH:mm:ss')
                }}</template>
              </el-table-column>
              <el-table-column label="操作">
                <template scope="props">
                  <router-link :to="'/logistics/' + props.row.orderId">
                    <el-button type="text">详细</el-button>
                    <!-- <el-button type="text" @click="toLogisticsByCode(props.row.orderCode)">详细</el-button> -->
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="repair">
            <router-link to="/repair">
              <el-button class="more" type="primary" size="mini"
                >查看更多</el-button
              >
            </router-link>
            <h4 class="table-title">维修</h4>
            <el-table
              class="horizontal-padding-10-table"
              :data="HomeData.repairOrders"
            >
              <el-table-column
                label="维修单号"
                prop="orderCode"
                min-width="150px"
              ></el-table-column>
              <el-table-column label="维修状态" min-width="160px">
                <template scope="props">{{
                  props.row.state | OrderState
                }}</template>
              </el-table-column>
              <el-table-column label="维修时长" min-width="160px">
                <template scope="props"
                  >{{ props.row.durationDays }}天</template
                >
              </el-table-column>
              <el-table-column label="处理时间" min-width="280px">
                <template scope="props">{{
                  props.row.startTime | date('YYYY/MM/DD HH:mm:ss')
                }}</template>
              </el-table-column>
              <el-table-column label="操作" min-width="80px">
                <template scope="props">
                  <router-link :to="'/repair/' + props.row.orderId">
                    <el-button type="text">详细</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </v-card>
      </el-col>
    </el-row>
    <el-row class="row" :gutter="20" type="flex">
      <el-col :span="6">
        <!-- 公告、动态 -->
        <!-- <el-tabs class="custom-tab" type="border-card">
            <el-tab-pane label="公告">
              <ul class="list">
                <li class="item" v-for="(announcement, $index) in HomeData.announcements" :key="$index">
                  <router-link to="/">
                    <span class="article-title">{{announcement.title}}</span>
                  </router-link>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs> -->
        <v-card class="news" style="height: 100%; min-height: 265px">
          <!-- <span class="more">查看更多></span> -->
          <h4>公告</h4>
          <h5 style="padding-bottom: 5px">尊敬的用户：</h5>
          <p style="font-size: 14px; text-indent: 2em; line-height: 2em">
            您好！感谢您长期以来对我们业务的支持与信任，我们始终坚持以服务为客户创造价值，经团队不断创新开发的客户应用系统正式上线了，欢迎参与操作体验。
          </p>
          <!-- <ul class="list">
              <li class="item" v-for="(announcement, $index) in HomeData.announcements" :key="$index">
                <router-link to="/">
                  <span class="article-title">{{announcement.title}}</span>
                </router-link>
                <span class="date">{{announcement.publishedOn | date('YYYY/MM/DD')}}</span>
              </li>
            </ul> -->
        </v-card>
      </el-col>
      <el-col :span="18">
        <!-- 帮助中心 -->
        <v-card class="menu-panel max-height">
          <h4><router-link to="/help">帮助中心</router-link></h4>
          <el-row
            type="flex"
            justify="space-between"
            style="padding: 5px 20px 0"
          >
            <el-col>
              <h4 class="menu-title">委托管理</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/委托业务简介"
                    >委托业务简介</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/委托订单列表"
                    >委托订单列表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/租赁收入列表"
                    >租赁收入列表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/出售收入列表"
                    >出售收入列表</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">租赁管理</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/租赁业务简介"
                    >租赁业务简介</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/租赁业务简介"
                    >租赁订单查询</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/租赁价格查询"
                    >租赁价格查询</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">库存查询</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/合作库库存"
                    >合作库库存</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/代管库库存"
                    >代管库库存</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">维修查询</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/维修业务简介"
                    >维修业务简介</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/维修下单列表"
                    >维修下单列表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/维修价格查询"
                    >维修价格查询</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">物流信息查询</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/安全箱物流列表"
                    >安全箱物流列表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/发货单列表"
                    >发货单列表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/物流订单列表"
                    >物流订单列表</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">财务查询</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/委托收益报表"
                    >委托收益报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/委托销售报表"
                    >委托销售报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/维修支出报表"
                    >维修支出报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/物流支出报表"
                    >物流支出报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/租赁支出报表"
                    >租赁支出报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/保证金报表"
                    >保证金报表</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/代管库支出报表"
                    >代管库支出报表</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">订单管理</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/发货通知单"
                    >发货通知单</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/采购询价单"
                    >采购询价单</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/委托申请单"
                    >委托申请单</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/调度申请单"
                    >调度申请单</router-link
                  >
                </li>
              </ul>
            </el-col>
            <el-col>
              <h4 class="menu-title">个人中心</h4>
              <ul class="normal-list">
                <li class="normal-item">
                  <router-link class="link" to="/helpList/公司信息"
                    >公司信息</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/服务网点维护"
                    >服务网点维护</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/工程师信息维护"
                    >工程师信息维护</router-link
                  >
                </li>
                <li class="normal-item">
                  <router-link class="link" to="/helpList/在线反馈"
                    >在线反馈</router-link
                  >
                </li>
              </ul>
            </el-col>
          </el-row>
        </v-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
import StepsBar from '@/components/common/StepsBar'
export default {
  data() {
    return {
      picList: ['../../assets/banner.png'],
      Articles: [],
      HomeData: {},
      select: null,
      quickEntrys: [
        {
          name: '租赁列表',
          index: '/lease',
        },
        {
          name: '维修列表',
          index: '/repair',
        },
        {
          name: '委托列表',
          index: '/entrust',
        },
        {
          name: '租赁收入列表',
          index: '/entrust_lease',
        },
        {
          name: '出售收入列表',
          index: '/entrust_sell',
        },
        {
          name: '发货通知单',
          index: '/leaseSent_order',
        },
        {
          name: '自己委托库',
          index: '/trust',
        },
        {
          name: '调度单列表',
          index: '/dispatch_order',
        },
        {
          name: '采购询价单',
          index: '/purchase_order',
        },
        {
          name: '代管总库存',
          index: '/managed',
        },
        {
          name: '委托收益报表',
          index: '/entrustedIncome_statement',
        },
        {
          name: '租赁支出报表',
          index: '/leaseExpenditure_statement',
        },
        {
          name: '保证金支出报表',
          index: '/deposit_statement',
        },
      ],
      inventorySearch: {
        type: '1',
        word: '',
      },
      leaseSearch: {
        word: '',
        modelId: '',
      },
      repairSearch: {
        word: '',
      },
    }
  },
  methods: {
    initArticles() {
      const queryWhere = {
        Index: 1,
        Size: 4,
      }
      this.$http
        .get(`${process.env.API_HOST}/Article`, {
          params: queryWhere,
        })
        .then(({ data }) => {
          this.IsLoading = false
          this.Articles = data.list
        })
        .catch((error) => {
          this.IsLoading = false
          this.$eventHub.$emit('showErrorMessage', error)
        })
    },
    // 快速入口菜单点击事件
    menuSelect(key, keypath) {
      // 如果是调转至自己委托，附加上跳转flag
      if (key === '/trust') {
        this.$store.dispatch('SET_TRUST_LIST_PAGE_TARGET', 'self')
      }
    },
    // 格式化表格,物品名称如果过长则截取过长的部分用'...'来替代
    formatProductTable({ productName }) {
      if (productName && productName.length > 12) {
        return productName.substring(0, 12) + '...'
      } else {
        return productName
      }
    },
    toTrustApply() {
      this.$router.push('/managed')
      window.localStorage.setItem('orderUrl', 'trustapply')
    },
    toShip() {
      this.$router.push('/managed')
      window.localStorage.setItem('orderUrl', 'shipapply')
    },
    getHomeData() {
      this.$http
        .get('services/app/home/GetHomeData')
        .then(({ data }) => {
          console.log('获取首页数据')
          this.HomeData = data
          console.log(data)
        })
        .catch((error) => {
          // this.$alert(error)
          console.error(error)
        })
    },
    handleSeach(type) {
      switch (type) {
        case 'inventory':
          if (this.inventorySearch.type === '1') {
            this.$router.push({
              path: '/managed',
              query: { product: this.inventorySearch.word },
            })
          } else {
            this.$router.push({
              path: '/entrusted',
              query: { product: this.inventorySearch.word },
            })
          }
          break
        case 'lease':
          this.$router.push({
            path: '/leaseprice',
            query: { product: this.leaseSearch.word },
          })
          break
        case 'repair':
          this.$router.push({
            path: '/repairprice',
            query: { product: this.repairSearch.word },
          })
          break
      }
    },
    // 跳转至租赁价格列表页面，并根据产品名字显示
    toLeasePriceByModelName(productName) {
      this.$router.push({
        path: '/leaseprice',
        query: { product: productName },
      })
    },
    // 跳转至租赁价格列表页面，并根据机型Id显示
    toLeasePriceByModelId(modelId) {
      this.$router.push({ path: '/leaseprice', query: { modelId: modelId } })
    },
    // 跳转至维修价格列表页面，并根据模块Id显示
    toRepairPriceByModuleId(moduleId) {
      this.$router.push({ path: '/repairprice', query: { moduleId: moduleId } })
    },
    // 跳转至物流订单列表页面，并根据订单号显示
    toLogisticsByCode(logisticscode) {
      this.$router.push({
        path: '/logistics',
        query: { logisticscode: logisticscode },
      })
    },
  },
  created() {
    this.getHomeData()
    this.initArticles()
  },
  components: {
    vCard,
    StepsBar,
  },
}
</script>

<style lang="less" scoped>
.home-page {
  overflow-x: hidden;
}

.row {
  margin-bottom: 20px;
  align-items: stretch;
  flex-direction: row;
}

.carousel {
  border-radius: 6px;
  overflow: hidden;
}

h4 {
  margin: 0;
  margin-bottom: 10px;
  font-size: 16px;
}

.more {
  float: right;
  font-size: 12px;
  line-height: 14px;
}
.more1 {
  line-height: 24px;
}
.list {
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
  height: 160px;
  overflow-y: hidden;
  .item {
    list-style: none;
    display: flex;
    justify-content: space-between;
    height: 38px;
    line-height: 40px;
    border-bottom: 2px solid #eee;
    .article-title {
      margin: 0;
      font-size: 14px;
      flex: auto;
      color: #222;
      text-decoration: none;
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 20px;
    }
    .date {
      font-size: 12px;
      color: #999;
    }
  }
}

.news {
  height: 354px;
  .sub-row {
    margin-bottom: 8px;
  }
}
.action-bar-mg-top {
  margin-top: 10px;
}
.query-card {
  height: 264px;
  .form-item {
    margin: 10px 0;
  }
  .last-record {
    height: 52px;
    label {
      font-size: 12px;
    }
    p {
      text-align: center;
      font-size: 12px;
      color: #9b9b9b;
    }
  }
}

.menu {
  background-color: transparent;
  .menu-item {
    height: 46px;
    line-height: 46px;
    background-color: transparent;
    border-left: 4px solid transparent;
    color: #43484d;
    &:hover {
      background-color: #e5e9f2;
      border-left: 4px solid #707070;
      color: #43484d;
    }
    .fa {
      margin-right: 10px;
    }
  }
}

.table-title {
  line-height: 24px;
}

.inventory,
.logistics {
  margin-bottom: 20px;
}

.menu-panel {
  .menu-title {
    color: #20a0ff;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .normal-list {
    margin: 0;
    padding: 0;
    .normal-item {
      list-style: none;
      margin-bottom: 8px;
      font-size: 12px;
      .link {
        color: #43484d;
      }
    }
  }
}
</style>

<style lang="less">
.questionBtn {
  color: #999;
  padding: 0 10px 8px 0;
}
.questionBtn:hover,
questionBtn:active {
  color: #01aaed;
}
.query-card-textarea textarea {
  height: 80px;
  resize: none;
}
.el-button.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #20a0ff;
}
.el-tabs.custom-tab {
  border-radius: 4px;
  border: none;
  box-shadow: none;
  overflow: hidden;
  height: 100%;
  .el-tabs__header {
    border-bottom: none;
    .el-tabs__nav {
      width: 100%;
      display: flex;
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__item {
        flex: 1;
        text-align: center;
        font-size: 15px;
        font-weight: bold;
        color: #43484d;
        &.is-active {
          color: #0d66a7;
          background: #fff;
        }
      }
    }
  }
}
.el-input__inner {
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?2d6e21f4